//Hooks
import { get } from 'svelte/store';
//Formatters
import { format } from 'svelte-i18n';
//Stores
import { devices_settings } from 'src/stores/device-runtime/status';
//Types
import type { Device } from '../../../types/Device';
import type { SettingRequest } from '../../../types/requests/settings/setting';
import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
import { real_id } from 'src/helpers/interface_helpers';

export const onWifiResponse = (res: SettingRequest, ssid: string, enable: boolean, device: Device) => {
	const $format = get(format),
		toastTexts = {
			success: enable
				? $format('wifi_scc_toast', {
						values: { ssid },
						default: 'Your device will connect to {ssid}.',
					})
				: $format('wifi_disable_scc_toast', {
						default: 'Wi-Fi successfully disabled.',
					}),
			denger: $format('wifi_err_toast', {
				default: 'Error! Failed to save Wi-Fi settings.',
			}),
		};
	onSettingsResponse(res, device, toastTexts, true);
};

//Checking the last access point connection.
export const isLastAPConnection = (deviceID: string): boolean => {
	const settings = devices_settings.getByRealId(deviceID);
	let countConn = 0;
	[
		settings?.wifi?.sta?.enable,
		settings?.wifi?.sta1?.enable,
		settings?.wifi?.ap?.enable,
		settings?.eth?.enable,
		settings?.ble?.enable,
	].forEach((i) => {
		countConn += Number(i) || 0;
	});
	return countConn < 2;
};
